<template>
  <div class="cred-row py-2">
    <div class="caption text--secondary">{{ label }}</div>
    <div class="d-flex align-center">
      <span class="cred-row__value flex-grow-1">
        {{ display }}
      </span>
      <v-btn
        v-if="secret"
        icon
        small
        class="flex-shrink-0"
        @click="revealed = !revealed">
        <v-icon small>{{ revealed ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
      </v-btn>
      <v-btn icon small class="flex-shrink-0" @click="$emit('copy', value)">
        <v-icon small>mdi-content-copy</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CredentialRow',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    secret: { type: Boolean, default: false },
  },
  data() {
    return {
      revealed: false,
    }
  },
  computed: {
    display() {
      const v = this.value == null ? '' : String(this.value)
      if (!v) return '—'
      // Fixed-width mask: don't leak the secret's length.
      if (this.secret && !this.revealed) return '••••••••'
      return v
    },
  },
}
</script>

<style scoped>
.cred-row {
  border-bottom: thin solid rgba(0, 0, 0, 0.08);
}
.cred-row__value {
  font-family: 'Roboto Mono', monospace;
  font-size: 1.15rem;
  font-weight: 500;
  word-break: break-all;
  user-select: all;
}
</style>
